import React, { FunctionComponent } from 'react'
import CollapsingItem from '../Common/CollapsingItem'
import Row from '../Common/Row'
import { Text } from '@wework/dieter-ui'
import css from './Pricing.module.scss'

interface PricingProps {
  space: any
}

interface PriceData {
  type: string
  timeFrame: string
  price: string | number
}

const Pricing: FunctionComponent<PricingProps> = ({ space }) => {
  const pricing: Array<PriceData> = space.pricing || [
    { type: 'Peack', timeFrame: '1100 - 1600', price: 1.5 },
    { type: 'Default', timeFrame: '1100 - 1600', price: 1.0 },
  ]
  const getPriceItem: (priceData: PriceData) => JSX.Element = ({
    type,
    timeFrame,
    price,
  }) => {
    return (
      <Row key={type} className={css.pricingItem} justify={'space-between'}>
        <div>
          <Text className={css.pricingText}>{type}</Text>
          <Text className={css.timeFrame}>{timeFrame}</Text>
        </div>
        <Text className={css.pricingText}>{`${price} credit`}</Text>
      </Row>
    )
  }

  return (
    <CollapsingItem title={'Pricing'}>
      {pricing.map(priceData => getPriceItem(priceData))}
    </CollapsingItem>
  )
}

export default Pricing
